export function uppercaseFirst(str: string) {
  return `${str.charAt(0).toUpperCase()}${str.substring(1)}`;
}

export function isString(str: any): str is string {
  return typeof str === 'string' || str instanceof String;
}
